import React from 'react';
import { JSONLD } from '../../../components/JSONLD';
export type WellnessArticlePageJSONLDProps = {
  structuredData: {
    article: unknown;
    breadcrumbs: unknown;
    videos: unknown[];
  };
};
export const WellnessArticlePageJSONLD = ({
  structuredData
}: WellnessArticlePageJSONLDProps) => <>
    <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="index.tsx">
      {structuredData.article}
    </JSONLD>
    <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="index.tsx">
      {structuredData.breadcrumbs}
    </JSONLD>
    {structuredData.videos && structuredData.videos.filter((video: {
    embedUrl: string;
  }) => video.embedUrl).map((video: {
    embedUrl: string;
  }) => <JSONLD key={video.embedUrl}>
            {video}
          </JSONLD>)}
  </>;